import React from 'react';

import classNames from 'classnames';
import { highlightText } from '../../../../utils/highlightText';
import { getImageUrl } from '../../../../utils/cardImage';
import styles from './renderOption.module.css';

export default (searchString) => (element) => {
  const { name, id, oracle_id, imgKey, owned } = element;

  return {
    value: oracle_id,
    key: id,
    label: (
      <div className={styles.option}>
        <div className={styles.cardImageWrapper}>
          <img className={styles.cardImage} src={getImageUrl(id, imgKey)} alt={name} />
        </div>
        <span className={classNames(styles.name, { [styles.nameShort]: owned })}>
          {highlightText(searchString, name)}
        </span>
        <span className={styles.ownedTag}>{owned && 'owned'}</span>
      </div>
    ),
  };
};
